import { ref } from 'vue';
import { useRoute } from 'vue-router';

export const useSubdomain = () => {
  const route = useRoute();

  if (route?.params?.store_slug) {
    return ref(route.params.store_slug);
  }

  return useState<string>('subdomain', () => null);
};
